import React from 'react';
import { Card } from './components/Card';
import { Flex, Text } from '@chakra-ui/react';
import { FaRegStar } from 'react-icons/fa';
import { RoundedNumber } from './components/RoundedNumber';
import { Link } from 'react-router-dom';

export const ClientesImportantes = ({ codCustomerSelected, infoCustomer, isLoading }) => {
  return (
    <Card py={'10px'} px={'80px'} mt={2} isLoading={isLoading}>
      <Flex
        alignItems="center"
        justifyContent="center"
        gap={4}
        as={Link}
        to={`/clientes-importantes/${codCustomerSelected}?cliente_especial=true`}>
        <FaRegStar size={35} color="#FFA200" />
        <Text color="#2D2D2D" fontSize="21px" fontWeight="semibold">
          Clientes Importantes
        </Text>
        <RoundedNumber
          number={infoCustomer?.clientes_importantes}
          bgColor="#F5F5F5"
          color="#FFA200"
          w="45px"
          h="45px"
          fontSize="23px"
          to={`/clientes-importantes/${codCustomerSelected}?cliente_especial=true&valida_parceiro=true`}
        />
      </Flex>
    </Card>
  );
};
